import { useReducedMotion } from "@/hooks/useReducedMotion";

export const SplineBackground = () => {
  const prefersReducedMotion = useReducedMotion();

  if (prefersReducedMotion) return null;

  return (
    <div
      className="pointer-events-none absolute inset-x-0 -top-48 sm:-top-24 bottom-0 z-0 overflow-hidden"
      aria-hidden="true"
    >
      <spline-viewer
        url="https://prod.spline.design/1I12XspzYrSLAUGl/scene.splinecode"
        style={{ width: "100%", height: "100%", display: "block" }}
      />
    </div>
  );
};
